module.exports = __webpack_public_path__ + "assets/e99e25eaf7ac75ded77974741ee34504.svg";